import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import { __t } from '@mssgme/shared';
import { LandingsPropTypes } from '@mssgme/ui';
import { useCRMData, useFrontAPI, BACKEND_ENDPOINTS, useWebsiteData } from '../../../hooks';
import LiqpayButton from './Buttons/LiqpayButton';

const propTypes = {
    order: LandingsPropTypes.order.isRequired,
    disabled: PropTypes.bool,
};

export function LiqpayPayment({ order, disabled }) {
    const api = useFrontAPI();
    const orderReference = `${order._id}_uniq${Math.floor(Math.random() * 100000)}`;
    const { payments } = useCRMData();
    const { finalUrl } = useWebsiteData();
    const description = `${__t('payment_for_order')}${order._id}:\n\n${order.items
        .map(
            (product, index) =>
                `${index + 1}. ${product.name} ${product.quantity}x${product.price.amount}${product.price.currency}\n`
        )
        .join('')}\n\n${finalUrl}`;
    const { successUrl, serverUrl } = useMemo(
        () => ({
            successUrl: document.location.href,
            serverUrl: BACKEND_ENDPOINTS.getLiqPayCallback(order),
        }),
        [order]
    );

    const createSignature = useCallback(
        (payload) => api.orders.signatures.createLiqpaySignature({ orderId: order._id, payload }),
        [order._id]
    );

    return (
        <LiqpayButton
            publicKey={payments.liqpay.publicKey}
            amount={order.total.amount}
            currency={order.total.currency}
            orderId={orderReference}
            description={description}
            createSignature={createSignature}
            resultUrl={successUrl}
            serverUrl={serverUrl}
            disabled={disabled}
        />
    );
}

LiqpayPayment.propTypes = propTypes;
